import { render } from "./AnnualComposedChart.vue?vue&type=template&id=480d3332&scoped=true"
import script from "./AnnualComposedChart.vue?vue&type=script&lang=js"
export * from "./AnnualComposedChart.vue?vue&type=script&lang=js"

import "./AnnualComposedChart.vue?vue&type=style&index=0&id=480d3332&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-480d3332"]])

export default __exports__